import type { ContentDto, MovieContentDto } from "$src/core/models/dto";

const isMovieContent = (content: ContentDto): content is MovieContentDto =>
  content.type === "movies";

export default isMovieContent;
